export class ContractItem {

    constructor(apiItemData, isMobile) {
        this.data = apiItemData || {};
        this.isMobile = isMobile;
        this.filter = 'contracts';

        this.time = this.data?.time || 0;
        this.updated = this.time;
        this.deviceoutput = this.data?.deviceoutput || 'desktop';
        this.insuranceKey = this.data?.insuranceKey || '';

        this.productSpecificData = this.data?.productSpecificData || {};
        this.status = this.data?.status || {};
        this.tariff = this.data?.tariff || {};

        this.cta = this.data?.cta[0];
        if (this.data?.cta[1]) {
            this.cta = this.data?.cta[1];
        }

        this.ctaText = this.cta?.text || 'Ergebnis anzeigen';
        this.ctaType = this.cta?.type || '';
        this.ctaUrl = isMobile ? this.cta?.urlMobile : this.cta?.urlDesktop;
        this.deleteUrl = this.data?.urlDelete || '';
        this.categoryType = this.data?.type || 'lastSearches';

        this.fallbackImage = '/katzenversicherung/cat/files/hansemerkur_logo.png';
        this.animalAgeWeeks = this.productSpecificData?.animal_age_in_weeks || 0;
        this.providerLogo = this.productSpecificData?.provider_logo || '';
        this.paymentPeriod = this.tariff?.period || 'month';
        this.tariffName = this.tariff?.name || '';
        this.price = this.tariff?.price || 'month';
        this.leadId = 'HKV-' + this.productSpecificData?.lead_id || '';
    }

    static textMappings = {
        'waiting_period': {
            'all' : 'egal',
            '1'   : 'bis 1 Monat'
        },
    };

    get title() {
        if (this.data?.type === 'contract') {
            return 'Vertrag für ' + this.productSpecificData?.animal_name;
        }

        return 'Antrag vervollständigen'
    }

    get animalNameOrBreed() {
        if (this.productSpecificData?.animal_name) {
            return decodeURIComponent(this.productSpecificData.animal_name);
        }
        return this.productSpecificData?.animal_breed_name_1st || '';
    }

    get formattedPrice() {
        return this.price.toFixed(2).replace('.', ',');
    }

    get protection() {
        const map = {
            'op': 'OP-Schutz',
            'full': 'Vollschutz',
            'accident': 'Unfallschutz'
        };

        if (!this.productSpecificData?.protection) {
            return '';
        }

        return map[this.productSpecificData.protection] ?? '';
    }

    get protectionIcon() {
        if (this.productSpecificData?.protection === 'full') {
            return 'full-protection-icon';
        }

        return 'op-protection-icon';
    }

    get providerName() {
        if (this.productSpecificData?.provider_name === 'Deutsche Familienversicherung') {
            return 'DFV';
        }

        return this.productSpecificData?.provider_name;
    }

    get deviceLabel() {
        const map = {
            desktop: 'auf dem PC',
            mobile: 'auf dem Handy',
            app: 'in der App',
            tabletapp: 'in der App',
            tablet: 'auf dem Tablet',
        };

        return map[this.deviceoutput] || map.desktop;
    }

    get periodLabel() {
        const map = {
            year: 'jährlich',
            semester: 'halbjährlich',
            quarter: 'vierteljährlich',
            month: 'monatlich'
        };

        return map[this.paymentPeriod] || map.desktop;
    }

    get timeAgo() {
        const diffSec = Math.floor(Date.now() / 1000) - this.time;

        if (diffSec < 3600) {
            return 'vor Kurzem';
        }

        if (diffSec < 86400) {
            let diffHours = Math.floor(diffSec / 3600);
            if (diffHours <= 1) {
                return 'vor ' + diffHours + ' Stunde';
            }
            return 'vor ' + diffHours + ' Stunden';
        }

        const diffDays = Math.floor(diffSec / 86400);
        return 'vor ' + diffDays + ' Tagen';
    }

    get ageInWeeksToYears() {
        let ageNumber = parseInt(this.animalAgeWeeks, 10);

        const ageRanges = {
            0: '0 - 8 Wochen',
            8: '8 - 12 Wochen',
            12: '12 Wochen - 1 Jahr'
        };

        if (ageNumber >= 52) {
            let ageInYear = Math.floor(ageNumber / 52);
            return ageInYear + (ageInYear === 1 ? ' Jahr' : ' Jahre');
        }

        return ageRanges[ageNumber] || ageNumber + ' Wochen';
    }
}
